export const TOP_LEFT = "Orientation.TopLeft";
export const TOP_RIGHT = "Orientation.TopRight";
export const BOTTOM_LEFT = "Orientation.BottomLeft";
export const BOTTOM_RIGHT = "Orientation.BottomRight";

export default Object.freeze({
  TOP_LEFT,
  TOP_RIGHT,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
});
